import { useSearchBox } from 'react-instantsearch';

function CustomSearchBox() {
  const { query, refine, clear } = useSearchBox();

  return <></>;
}

export default CustomSearchBox;
